const BoostQueryKeys = {
  global: ["boosts"] as const,

  list: () => [...BoostQueryKeys.global, "list"] as const,
  detail: (uuid: string) => [...BoostQueryKeys.global, "detail", uuid] as const,
  eligibilityRoot: () => [...BoostQueryKeys.global, "eligibility"] as const,
  eligibility: (statusId?: string | null) =>
    [...BoostQueryKeys.eligibilityRoot(), statusId ?? "new"] as const,
};

export { BoostQueryKeys };
